// extracted by mini-css-extract-plugin
export default {"navigateButtonsContainer":"NavigateButtons_navigateButtonsContainer__fZkDF"};